import React from "react";
import Logo from "../assets/images/logo.png";
import { Link } from "react-scroll";

const Footer = () => {
  const navItems = [
    { label: "Home", href: "/" },
    { label: "Purpose of the Website", href: "purpose-of-website" },
    { label: "Our Mission", href: "our-mission" },
    { label: "250+ Country Meme Zones", href: "country-meme-zones" },
    { label: "SEO Command", href: "seo-command" },
  ];

  return (
    <footer className="bg-[#5C4033] text-[#F3E5AB] pt-16 pb-8 px-6 border-t-4 border-[#7B9E44]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 text-center md:text-left">
        {/* Identity */}
        <div>
          <img
            src={Logo}
            alt="TeaWasFantastic Logo"
            className="h-14 w-auto mb-4 mx-auto md:mx-0"
          />
          <h2 className="text-3xl font-[Orbitron] text-[#7B9E44] mb-3">
            TeaWasFantastic
          </h2>
          <p className="text-sm leading-relaxed">
            250 global fronts. One chai-fueled mission.
            <br />
            Pakistan’s Meme Division stands armed with truth.
          </p>
        </div>

        {/* Navigation */}
        <div>
          <h3 className="text-xl font-semibold mb-4 text-[#F3E5AB]">Navigation</h3>
          <ul className="space-y-2 text-sm">
            {navItems.map(({ label, href }) => (
              <li key={label}>
                <Link
                  to={href}
                  smooth={true}
                  duration={500}
                  className="cursor-pointer hover:text-[#FFF5D1] transition-all duration-300"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact & Social */}
        <div>
          <h3 className="text-xl font-semibold mb-4 text-[#F3E5AB]">Connect</h3>
          <p className="text-sm mb-3">📧 info@teawasfantastic.com</p>
          <div className="flex justify-center md:justify-start gap-4 text-xl">
            <a href="#" className="hover:text-[#FFF5D1] transition">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="#" className="hover:text-[#FFF5D1] transition">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="#" className="hover:text-[#FFF5D1] transition">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" className="hover:text-[#FFF5D1] transition">
              <i className="fab fa-pinterest"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Footer strip */}
      <div className="mt-12 pt-6 text-center text-xs border-t border-[#A67B5B] text-[#F3E5AB]">
        &copy; {new Date().getFullYear()} TeaWasFantastic. All rights reserved.
        <br />
        Crafted with chai & courage 🇵🇰
      </div>
    </footer>
  );
};

export default Footer;
